module.exports = __webpack_public_path__ + "img/fail.8fc475e9.png";